// extracted by mini-css-extract-plugin
export default {"helicopter-animation":"styles_helicopter-animation__sLQOn","balloon-animation":"styles_balloon-animation__ykHRD"};